module.exports = "<paging\n        page=\"pgObject.current_page\"\n        page-size=\"pgObject.per_page\"\n        total=\"pgObject.total_count\"\n        paging-action=\"action({page: page})\"\n        adjacent=\"1\"\n        hide-if-empty=\"true\"\n        show-prev-next=\"true\"\n        show-first-last=\"false\"\n        text-next=\"次へ >\"\n        text-prev=\"< 前へ\">\n</paging>\n"


//////////////////
// WEBPACK FOOTER
// ./public/dev/components/directive/pagination-directive/pagination.html
// module id = 687
// module chunks = 0